/**
 * Fractal-noise turbulence as an inline SVG data URI, ready to drop into
 * `background-image`.
 *
 * Layered over a flat fill or gradient at low opacity (usually with
 * `mix-blend-overlay`) it breaks up banding and gives generated art the grain
 * that keeps it from looking like plain CSS.
 */
export const NOISE_BACKGROUND =
    'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 180 180%27%3E%3Cfilter id=%27n%27 x=%270%27 y=%270%27 width=%27100%25%27 height=%27100%25%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url(%23n)%27 opacity=%270.82%27/%3E%3C/svg%3E")';

/**
 * Fine monochrome film grain — the restrained sibling of `NOISE_BACKGROUND`.
 *
 * Four deliberate choices make it read as grain rather than dirt:
 * `feColorMatrix saturate=0` strips the colour, so it can't speckle random hues
 * over a tinted surface; a single octave keeps it high-frequency instead of
 * cloudy; `baseFrequency` is high enough that the speckle stays finer than the
 * eye resolves as texture; and the 100-unit tile is meant to be painted at 1:1
 * (`backgroundSize: '100px 100px'`) so it is never resampled into a smudge.
 *
 * Pair it with `mix-blend-overlay` at a high opacity — counter-intuitively,
 * gentler blends (soft-light) read as haze rather than grain, because they
 * flatten the per-pixel contrast that makes the texture legible.
 */
export const GRAIN_BACKGROUND =
    'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 100 100%27%3E%3Cfilter id=%27g%27 x=%270%27 y=%270%27 width=%27100%25%27 height=%27100%25%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%271.6%27 numOctaves=%271%27 stitchTiles=%27stitch%27/%3E%3CfeColorMatrix type=%27saturate%27 values=%270%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url(%23g)%27/%3E%3C/svg%3E")';
